import kyber from "./kyber.faq";
import kava from "./kava.faq";
import cosmos from "./cosmos.faq";
import band from "./band.faq";
import terra from "./terra.faq";
import starname from "./starname.faq";
import switcheo from "./switcheo.faq";
import skale from "./skale.faq";
import persistence from "./persistence.faq";
import sentinel from "./sentinel.faq";
import thegraph from "./thegraph.faq";
import osmosis from "./osmosis.faq";
import certik from "./certik.faq";
import celer from "./celer.faq";
import juno from "./juno.faq";
import comdex from "./comdex.faq";
import lum from "./lum.faq";
import gbridge from "./gbridge.faq";
import akash from "./akash.faq";
import agoric from "./agoric.faq";
import evmos from "./evmos.faq";
import injective from "./injective.faq";
import passage3d from "./passage3d.faq";
import sifchain from "./sifchain.faq";
import solana from "./solana.faq";
import quicksilver from "./quicksilver.faq";
import sui from "./sui.faq";
import kujira from "./kujira.faq";
import archway from "./archway.faq";
import celestia from "./celestia.faq";
import dydx from "./dydx.faq";
import dymension from "./dymension.faq";
import canto from "./canto.faq";

export default {
  kyber,
  cosmos,
  kava,
  band,
  terra,
  starname,
  switcheo,
  skale,
  persistence,
  sentinel,
  thegraph,
  osmosis,
  certik,
  celer,
  juno,
  comdex,
  lum,
  gbridge,
  akash,
  agoric,
  evmos,
  injective,
  passage3d,
  sifchain,
  solana,
  quicksilver,
  sui,
  kujira,
  archway,
  celestia,
  dydx,
  dymension,
  canto,
};
